<div class="container" *ngIf="salesOrder$ | async as salesOrder">
  @if (isLoading) {
    <div class="overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'MESSAGES.LOADING' | translate }}</span>
      </div>
    </div>
  }

  <div class="row align-items-center justify-content-between pb-3">
    <div class="col-12 col-sm-auto mb-2 mb-md-0">
      <a routerLink="../../" class="button">{{ 'BUTTONS.BACK' | translate }}</a>
    </div>

    <div class="col-12 col-sm-auto me-auto justify-content-center">
      <h1 class="title mb-0">{{ salesOrder.number || notFound }}</h1>
    </div>

    <div class="col col-auto d-lg-block d-none my-2">
      <app-navbar-profile-info></app-navbar-profile-info>
    </div>
  </div>

  <div class="box-shadow-block form">
    <h2 class="section-title">Sales order</h2>

    <div class="meta-grid mb-4">
      <div class="meta-item">
        <div class="meta-label">Number</div>
        <div class="meta-value">{{ salesOrder.number || notFound }}</div>
      </div>
      <div class="meta-item">
        <div class="meta-label">Customer number</div>
        <div class="meta-value">{{ salesOrder.customerNumber || notFound }}</div>
      </div>
      <div class="meta-item">
        <div class="meta-label">Order date</div>
        <div class="meta-value">{{ (salesOrder.orderDate | date: 'yyyy-MM-dd') || notFound }}</div>
      </div>
      <div class="meta-item">
        <div class="meta-label">Posting date</div>
        <div class="meta-value">{{ (salesOrder.postingDate | date: 'yyyy-MM-dd') || notFound }}</div>
      </div>
      <div class="meta-item">
        <div class="meta-label">Requested delivery</div>
        <div class="meta-value">
          {{ (salesOrder.requestedDeliveryDate | date: 'yyyy-MM-dd') || notFound }}
        </div>
      </div>
    </div>

    <h3 class="section-subtitle">Order lines</h3>

    <div class="table-wrapper">
      <table class="table table-sm lines-table">
        <thead>
          <tr>
            <th>Sequence</th>
            <th>Type</th>
            <th>Description</th>
            <th>Qty</th>
            <th>Unit price</th>
            <th>Discount %</th>
            <th>Net amount</th>
            <th>Shipment date</th>
          </tr>
        </thead>
        <tbody>
          @for (line of salesOrder.lines; track line.id) {
            <tr>
              <td>{{ line.sequence }}</td>
              <td>{{ line.lineType || notFound }}</td>
              <td>{{ line.description || line.description2 || notFound }}</td>
              <td>{{ line.quantity | number: '1.2-2' }}</td>
              <td>{{ line.unitPrice | number: '1.2-2' }}</td>
              <td>{{ line.discountPercent | number: '1.2-2' }}</td>
              <td>{{ line.netAmount | number: '1.2-2' }}</td>
              <td>{{ (line.shipmentDate | date: 'yyyy-MM-dd') || notFound }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="8" class="text-center">{{ notFound }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
